import { render, staticRenderFns } from "./SubUserCreation.vue?vue&type=template&id=37f1d4a8&scoped=true"
import script from "./SubUserCreation.vue?vue&type=script&lang=js"
export * from "./SubUserCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f1d4a8",
  null
  
)

export default component.exports